import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';

export const baseGridCell = (theme: JupiterTheme) =>
  createStyles({
    class: {
      alignItems: 'center',
      backgroundColor: 'rgba(246, 246, 246, .95)',
      display: 'flex',
      flexFlow: 'column',
      justifyContent: 'center',
      margin: 1,
      overflow: 'hidden',
      height: 122,
      padding: theme.spacing(1.5, 2),
      position: 'relative',
      textDecoration: 'none',
      minWidth: 224,
      flex: '1 0',
      '&:after': {
        backgroundColor: theme.palette.navy[900],
        borderRadius: '50%',
        content: `''`,
        display: 'block',
        height: 1000,
        opacity: 0,
        top: 24,
        position: 'absolute',
        width: 1000,
        zIndex: 0,
      },
    },
  });

export const iconStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    bgIconGroup: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
      height: 1200,
      position: 'absolute',
      width: 1200,
      bottom: 50,
    },
    bgIcon: {
      color: theme.palette.secondary.main,
      width: 48,
      height: 48,
      strokeWidth: 1.5,
    },
    bgIconNoApps: {
      color: theme.palette.error.main,
      width: 48,
      height: 48,
      strokeWidth: 1.5,
    },
    lockIcon: {
      position: 'absolute',
      top: '0',
      left: '0',
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
      stroke: theme.palette.coolGrey[400],
    },
  });
});
export const gridStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    gridCellNoHover: {
      ...baseGridCell(theme).class,
      '&:hover': {
        '& $learnMore': {
          textDecoration: 'underline',
        },
      },
    },

    gridCell: {
      ...baseGridCell(theme).class,
      '&:hover': {
        color: theme.palette.text.dark,
        '&:after': {
          opacity: 1,
          height: 1200,
          transition: '.35s cubic-bezier(0.2, 0.8, 0.2, 1)',
          mixBlendMode: 'overlay',
          width: 1200,
          top: -1000,
        },
        '& $appName': {
          color: theme.palette.quartary.contrastText,
          background: theme.palette.text.dark,
        },
      },
    },
  });
});
